import { FirebaseWrapper } from "../firebase/FirebaseBaseWrapper";

export class CloudManagerBase {
    private firebaseToken: string | null = null;
    get firebaseAuthToken(): string | null {
        return this.firebaseToken;
    }
    private username: string | null = null;


    private get cloudUserId(): string | undefined {
        let auth = FirebaseWrapper.FirebaseBaseWrapper.shared.firebaseAuth
        return auth?.currentUser?.uid;
    }

    get userId(): string {
        return this.cloudUserId ? this.cloudUserId : (this.username ?? '')
    }

    get isLoggedIn(): boolean {
        return !!this.cloudUserId;
    }

    async setFirebaseToken(token: string, username?: string): Promise<string | null> {
        this.firebaseToken = token;
        this.username = username ?? null;
        const credential = await FirebaseWrapper.FirebaseBaseWrapper.shared.signInUser(token);
        return credential?.user.uid ?? FirebaseWrapper.FirebaseBaseWrapper.shared.firebaseAuth?.currentUser?.uid ?? null;
    }

    async logout() {
        this.firebaseToken = null;
        this.username = null;
        await FirebaseWrapper.FirebaseBaseWrapper.shared.signOutUser();
    }
}
